import styled from 'styled-components'
import { themeColor } from '@edulastic/colors'
import { Slider } from 'antd'

// a min of 8px of separation in the text that is displated for mastery slider
export const SLIDER_READING_MIN_SEPARATION = 8

export const StyledSlider = styled(Slider)`
  width: 87%;
  height: 6px;
  margin: 16px 10px 0px 10px;
  > div {
    height: 10px;
  }
  .ant-slider-rail {
    height: 6px;
  }
  .ant-slider-handle {
    height: 20px;
    width: 20px;
    margin-top: -7px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    box-shadow: 0px 6px 13px rgba(0, 0, 0, 0.12);
  }
  .ant-slider-track {
    height: 6px;
    background: ${themeColor};
  }
  .ant-slider-dot {
    display: none;
  }
  &:hover {
    & .ant-slider-track {
      background: ${themeColor};
    }
  }
  ${(props) => props.sliderStyles && props.sliderStyles}
`

export const SliderMarkContainer = styled.div`
  font-weight: 600;
  font-size: 11px;
  line-height: 18px;
  color: #777777;
  margin-top: 2px;
  padding-left: 0.75em;
  ${(props) => props.markStyles && props.markStyles}
`
